///Users/aminb101/iuhimporter/iuh-importer/frontend/src/utils/api.js
import { API_BASE_URL } from '../services/api';
export const API_URL = API_BASE_URL;


